<template>
  <div class="loadingSpinner">
    <div class="loadingSpinner__cube"></div>
    <div class="loadingSpinner__text">
      {{label}}
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        label: 'Loading Room'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Spinner.vue